export const MC0655_LIMITS = {
  documents: {
    starterLimit: 5000
  },
  templates: {
    starterLimit: 5000
  },
  'object-lists-dynamic': {
    starterLimit: 5000
  },
  snippets: {
    starterLimit: 5000
  },
  dashboards: {
    starterLimit: 10
  },
  'cms-blog-posts': {
    starterLimit: 10000
  },
  'pipeline-deals': {
    starterLimit: 2
  },
  'pipeline-tickets': {
    starterLimit: 2
  },
  email_sends: {
    starterLimit: 5000
  },
  'core-seats': {
    starterLimit: 'unlimited'
  },
  'crm-products': {
    starterLimit: 1000000
  }
};